import { render, staticRenderFns } from "./vipCard.vue?vue&type=template&id=eddd6736&scoped=true&"
import script from "./vipCard.ts?vue&type=script&lang=js&"
export * from "./vipCard.ts?vue&type=script&lang=js&"
import style0 from "./vipCard.less?vue&type=style&index=0&id=eddd6736&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd6736",
  null
  
)

export default component.exports